import styled from '@emotion/styled';

export default styled.div({
    gap: '1rem',
    display: 'flex',
    alignItems: 'center'
});
